const Administrators = () => import("./views/Administrators.vue");
const AdministratorEdit = () => import("./views/AdministratorEdit.vue");

const route = "/administrators";

export default [
  {
    path: route,
    name: "administrators.list",
    component: Administrators,

    meta: {
      roles: ["ROLE_ADMIN"],
    },
  },

  {
    path: `${route}/create`,
    name: "administrators.create",
    component: AdministratorEdit,

    meta: {
      roles: ["ROLE_ADMIN"],
    },
  },

  {
    path: `${route}/:administratorId/edit`,
    name: "administrators.edit",
    component: AdministratorEdit,

    props: true,

    meta: {
      roles: ["ROLE_ADMIN"],
    },
  },
];
